/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get, omit } from 'lodash';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import RequirementsPicker from 'shared/ui/components/form-components/pickers/RequirementsPicker.vue';
import TemplateFieldsMetadata from './TemplateFieldsMetadata.vue';

const __vue_script__ = {
    name: 'LegalDocumentFormWithTemplate',

    components: { BaseInput, BaseSelect, Checkbox, RequirementsPicker, TemplateFieldsMetadata },

    props: {
        templates: {
            type: Array,
            default: () => [],
        },

        legalDoc: {
            type: Object,
            default: () => {},
        }
    },

    data() {
        return {
            currentTemplate: {},
            template: {},
            title: '',
            requirements: [],
            checkedDisclaimer: false,
            templateFields: {},
        };
    },

    mounted() {
        if (this.legalDoc.template) {
            this.template = this.templates.find(d => d._id === this.legalDoc.template);
        } else if (this.templates.length) {
            // select default template, or the first one, if none have the default_privacy_policy flag
            this.template = this.templates.find(d => d.default_privacy_policy) || this.templates[0];
        }

        this.setCurrentTemplate(this.template);

        this.requirements = get(this.legalDoc, ['template_fields', 'requirements'], []);
        this.title = get(this.legalDoc, ['template_title'], '');
        this.checkedDisclaimer = get(this.legalDoc, ['use_ackd'], false);
    },

    methods: {
        async setCurrentTemplate(template = {}) {
            if (template._id) {
                this.currentTemplate = await this.$services.legal.getDocumentTemplate(template._id);

                if (template._id !== get(this.legalDoc, ['template'])) {
                    const templateRequirements = this.currentTemplate.requirements || {};
                    this.requirements = templateRequirements.en || Object.entries(templateRequirements)[0] || [];
                } else {
                    this.requirements = get(this.legalDoc, ['template_fields', 'requirements'], []);
                }

                this.templateFields = {};
                for (const [key, field] of Object.entries(this.currentTemplate.template_fields_metadata || {})) {
                    const value = get(this.legalDoc, ['template_fields', key]) || field.default || '';
                    this.templateFields[key] = value;
                }

                this.onChange();
            }
        },

        onTemplateFieldsChange(templateFields) {
            this.templateFields = templateFields;
            this.onChange();
        },

        onChange() {
            const doc = omit({
                ...(this.legalDoc || {}),
                template: this.currentTemplate._id,
                template_title: this.title,
                template_fields: {
                    ...this.templateFields,
                    requirements: this.requirements,
                },
                use_ackd: this.checkedDisclaimer,
                requirements: this.requirements,
            }, ['title', 'text', 'url']);

            this.$emit('change', doc);
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legal-document-with-template" },
    [
      _c(
        "validation-observer",
        { ref: "form", attrs: { tag: "form" } },
        [
          _c("validation-provider", {
            attrs: { slim: true, name: "template" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c("base-select", {
                      attrs: {
                        name: "template",
                        label: _vm.$t("legal_documents.editor.template"),
                        options: _vm.templates,
                        optionsLabel: "title",
                      },
                      on: { input: _vm.setCurrentTemplate },
                      model: {
                        value: _vm.template,
                        callback: function ($$v) {
                          _vm.template = $$v
                        },
                        expression: "template",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("validation-provider", {
            attrs: { slim: true, name: "title" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c("base-input", {
                      attrs: {
                        name: "title",
                        label: _vm.$t("legal_documents.editor.title"),
                      },
                      on: { input: _vm.onChange },
                      model: {
                        value: _vm.title,
                        callback: function ($$v) {
                          _vm.title = $$v
                        },
                        expression: "title",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("validation-provider", {
            attrs: { slim: true, name: "disclaimer" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c("checkbox", {
                      attrs: {
                        name: "disclaimer",
                        label: _vm.$t(
                          "legal_documents.editor.template_disclaimer"
                        ),
                      },
                      on: { input: _vm.onChange },
                      model: {
                        value: _vm.checkedDisclaimer,
                        callback: function ($$v) {
                          _vm.checkedDisclaimer = $$v
                        },
                        expression: "checkedDisclaimer",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("template-fields-metadata", {
            attrs: {
              "fields-metadata": _vm.currentTemplate.template_fields_metadata,
            },
            on: { input: _vm.onTemplateFieldsChange },
            model: {
              value: _vm.templateFields,
              callback: function ($$v) {
                _vm.templateFields = $$v
              },
              expression: "templateFields",
            },
          }),
          _c("requirements-picker", {
            attrs: {
              label: _vm.$t("legal_documents.editor.requirements"),
              name: "requirements",
            },
            on: { input: _vm.onChange },
            model: {
              value: _vm.requirements,
              callback: function ($$v) {
                _vm.requirements = $$v
              },
              expression: "requirements",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/legal-documents/LegalDocumentFormWithTemplate.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__